import { render, staticRenderFns } from "./RouteActivityTag.vue?vue&type=template&id=2e8df4e7&scoped=true&lang=html&functional=true&"
import script from "./RouteActivityTag.vue?vue&type=script&lang=js&"
export * from "./RouteActivityTag.vue?vue&type=script&lang=js&"
import style0 from "./RouteActivityTag.vue?vue&type=style&index=0&id=2e8df4e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2e8df4e7",
  null
  
)

export default component.exports